/* Governance (Tab Mods) */

import { css } from 'styled-components';
import { media } from 'theme/utils';
import { styleBase, styleHero, styleReverse } from '../styles';

const Hero = {
  key: 'Hero',
  styledComponent: css`
    ${styleHero}

    &&& {
      padding-bottom: 11.4rem;
      background-size: 15.8rem;
      background-position: bottom 0 right;
      background-color: #1E99DC;

      ${media.md`
        padding-bottom: 2.6rem;
        background-size: 32rem;
        background-position: bottom 0 right -5.5rem;

        div[class*='descriptionWrapper'] {
          padding-right: 2.6em;
        }
      `}

      ${media.lg`
        padding: 0;
        background-size: contain;
        background-position: bottom -0.3rem right -12rem;

        div[class*='descriptionWrapper'] {
          max-width: 28em;
          padding-right: 0;
        }
      `}
    }
  `,
};

const State = {
  key: 'State',
  styledComponent: css`
    &&& {
      div[class*='content'] {
        padding: 2.6em 2em;

        div[class*='subtitle'] {
          padding: 0.3em 0 1.3em;
          color: unset;
          text-align: center;
        }
      }

      div[class*='featuresList'] {
        margin: 0;
        padding: 0;

        div[class*='feature'] {
          align-items: center;
          margin: 0;
          padding: 1.6em 0 0;

          img {
            max-width: 15em;
            max-height: unset;
          }

          div[class*='description'] {
            padding: 1.1em 0 0;

            h2 {
              font-size: 1.5em;
              font-weight: 800;
              line-height: 1;
              letter-spacing: -0.5px;
            }

            > div {
              padding-bottom: 1.3em;

              &:last-child {
                padding-bottom: 0;
              }
            }
          }
        }
      }

      ${media.md`
        div[class*='content'] {
          padding: 2.6em 4em 4em;

          div[class*='descriptionWrapper'] {
            h1 {
              margin: 0;
              padding: 0;
              line-height: 2;
            }
          }
        }

        div[class*='featuresList'] {
          padding: 0;

          div[class*='feature'] {
            align-items: flex-start;
            padding-top: 1.6em;

            img {
              flex: 1 0 22%;
              padding-top: 1.5em;
            }

            div[class*='description'] {
              margin-top: 0;
              padding-top: 0;
            }
          }
        }
      `}

      ${media.lg`
        div[class*='featuresList'] {

          div[class*='feature'] {

            img {
              flex-basis: 25%;
            }
          }
        }
      `}
    }
  `,
};

const Testing = {
  key: 'Testing',
  styledComponent: css`
    ${styleBase}
    ${styleReverse}

    &&& {
      div[class*='content'] {
        align-items: flex-start;
      }

      ul {
        margin: 0;
        padding: 0;
        list-style: none;
      }
    }
  `,
};

export const Governance = {
  key: '/responsibility-governance',
  content: [Hero, State, Testing],
};

export default Governance;
